import React from 'react'
import './nav.scss'

function nav({ navList, logo }) {
  return (
    <div className="nav_container">
      <a href="https://www.hololux.cn/"><img src={logo} alt="logo"></img></a>
    </div>
  )
}

export default nav

